<template lang="pug">
  v-container(grid-list-md v-if="!$root.$children[0].loading")
    v-flex(md12)
      v-card.elevation-12

        v-toolbar(dark color="primary" dense)
          v-toolbar-title Reporte Servicios Móvil {{ plate }}
          v-spacer
          v-btn(@click="$router.push('/reporte-flota')" flat)
            | Volver
            v-icon(right) undo
          v-btn(@click="closeSession()" flat)
            | Cerrar sesión
            v-icon(right) power_settings_new

        v-card-text
          v-layout(row wrap)
            v-flex(md2)
              v-select(
                v-model="month"
                label="Mes"
                :items="getMonths")
            v-flex(md2)
              v-select(
              v-model="year"
              label="Año"
              :items="getYears")

        v-card-text
          table(width="100%" align="center")
            thead
              tr
                th(align="left" width="220" height="30") Conductor
                th Móvil - Turno
                th Recos
                th Zarpes
                th RTX
                th Total
                th Monto
            tbody
              tr(v-for="driverServices in drivers" height="40")
                td(width="200" @click="$router.push('/reporte/' + month + '/' + year + '/' + driverServices[0].driver_id)"): span.link-name {{ driverServices[0].names }} {{ driverServices[0].last_names }}
                td(align="center" width="150") {{ driverServices[0].n_movil }}
                td(align="center") {{ countRecos(driverServices) }}
                td(align="center") {{ countZarpe(driverServices) }}
                td(align="center") {{ countRtx(driverServices) }}
                td(align="center") {{ countRecos(driverServices) + countZarpe(driverServices) + countRtx(driverServices) }}
                td(align="center") {{ countServicesPrice(driverServices) }}

          table.mt-5(width="100%" align="center" v-if="Object.keys(drivers).length > 1")
            thead
              tr
                th(width="180") Cantidad conductores
                th Recos
                th Zarpes
                th RTX
                th Total
                th Monto
            tbody
              tr
                td(align="center") {{ Object.keys(drivers).length }}
                td(align="center") {{ totalCountRecos }}
                td(align="center") {{ totalCountZarpe }}
                td(align="center") {{ totalCountRtx }}
                td(align="center") {{ totalCountRecos + totalCountZarpe + totalCountRtx }}
                td(align="center") {{ allServicesTotalMount | price }}

          table.mt-5.dense(width="100%" align="center" style="margin: auto")
            thead
              tr
                th
                th Porcentaje
                th Monto
            tbody
              tr
                td(align="center"): strong Total
                td(align="center") 100%
                td(align="center") {{ allServicesTotalMount | price }}
              tr
                td(align="center"): strong Descuento
                td(align="center") 20%
                td(align="center") {{ allServicesTotalMount * 0.2 | price }}
              tr
                td(align="center"): strong Liquido a pagar
                td(align="center") 80%
                td(align="center") {{ allServicesTotalMount * 0.8 | price }}

</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  moment.locale('es')

  export default {
    name: 'report',
    data: () => ({
      month: moment().format('MMMM'),
      year: parseInt(moment().format('gggg')),
      drivers: [],
      services: []
    }),
    created () {
      this.$root.$children[0].loading = true
      this.moment = moment.locale('es')
      if (!localStorage.getItem('token')) {
        this.$router.push('/')
      } else {
        this.loadData()
      }
    },
    mounted () {
      if (localStorage.getItem('month')) {
        this.month = localStorage.getItem('month')
      }
      if (localStorage.getItem('year')) {
        this.year = parseInt(localStorage.getItem('year'))
      }
    },
    computed: {
      getYears () {
        let years = []
        for (let year = 2017; year <= parseInt(moment().format('gggg')); year++) {
          years.push(year)
        }
        return years
      },
      getMonths () {
        let months = []
        for (let month = 1; month <= 12; month++) {
          months.push(moment(month, 'M').format('MMMM'))
        }
        return months
      },
      allServicesTotalMount () {
        if (!this.services.length) return '$ 0'
        return this.services.map(service => {
          return service.value
        }).reduce((oldValue, currentValue) => {
          return oldValue + currentValue
        })
      },
      plate () {
        if (this.drivers[Object.keys(this.drivers)[0]]) {
          return this.drivers[Object.keys(this.drivers)[0]][0].patente
        }
      },
      totalCountRecos () {
        let counter = 0
        this.services.forEach(service => {
          if (service.type === 'reco') counter++
        })
        return counter
      },
      totalCountZarpe () {
        let counter = 0
        this.services.forEach(service => {
          if (service.type === 'zarpe') counter++
        })
        return counter
      },
      totalCountRtx () {
        let counter = 0
        this.services.forEach(service => {
          if (service.type === 'rtx_reco' || service.type === 'rtx_zarpe') counter++
        })
        return counter
      }
    },
    methods: {
      loadData () {
        this.$http.get('services', {
          params: {
            month: moment(this.month, 'MMMM').format('M'),
            year: this.year,
            vehicleID: localStorage.getItem('vehicleID')
          }
        }).then(res => {
          this.drivers = _.groupBy(res.body, 'driver_id')
          this.services = res.body
          this.$root.$children[0].loading = false
        }).catch(res => {
          this.closeSession()
          this.$root.$children[0].loading = false
        })
      },
      countRecos (services) {
        let counter = 0
        services.forEach(service => {
          if (service.type === 'reco') counter++
        })
        return counter
      },
      countZarpe (services) {
        let counter = 0
        services.forEach(service => {
          if (service.type === 'zarpe') counter++
        })
        return counter
      },
      countRtx (services) {
        let counter = 0
        services.forEach(service => {
          if (service.type === 'rtx_reco' || service.type === 'rtx_zarpe') counter++
        })
        return counter
      },
      countServicesPrice (services) {
        let counter = 0
        services.forEach(service => {
          counter += service.value
        })
        return '$ ' + new Intl.NumberFormat('es-CL').format(counter)
      },
      closeSession () {
        localStorage.removeItem('month')
        localStorage.removeItem('year')
        localStorage.removeItem('token')
        localStorage.removeItem('vehicleID')
        localStorage.removeItem('tokenFlota')
        localStorage.removeItem('ownerID')
        setTimeout(() => {
          window.location.href = '/'
        }, 1000)
      }
    },
    watch: {
      month () {
        this.loadData()
      },
      year () {
        this.loadData()
      }
    },
    filters: {
      price (value) {
        return '$ ' + new Intl.NumberFormat('es-CL').format(parseInt(value))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/report.vue